export const frequentlyAsked = [
  {
    heading: 'Account & Login',
    questions: [
      {
        title: 'How do I log in if I am a new user?',
        discription: 'You can log in using Google Login with your Gmail ID, or create a new account using any valid email ID.',
      },
      {
        title: 'Do I need to provide my phone number?',
        discription: 'It’s optional, but recommended. Sharing your phone number helps us assist you quickly if you need support.',
      },
      {
        title: 'How do I recover my password?',
        discription:
          'Click Forgot Password on the login page. An OTP will be sent to your registered email ID. Use it to reset your password.',
      },
      {
        title: 'Can I change my email ID (User ID) after creating the account?',
        discription: 'Currently, you cannot change your registered email ID. We plan to add this feature soon.',
      },
      {
        title: 'How can I change my password?',
        discription: 'Click the Profile icon (top-right corner) → Select Change Password from the dropdown menu.',
      },
    ],
  },

  {
    heading: 'Company Setup & Management',
    questions: [
      {
        title: 'How many companies can I create under one user ID?',
        discription: 'You can create unlimited companies under your account.',
      },
      {
        title: 'Do I need to create a separate company for each financial year?',
        discription:
          'No, Keep all years under the same company. This allows easy year-to-year comparison of reports. Creating separate companies will prevent side-by-side comparison.',
      },
      {
        title: 'Can I use the same company name more than once?',
        discription:
          'No, The system doesn’t allow duplicate names. However, a slight variation (e.g., “Pvt Ltd” instead of “Private Ltd”) will work.',
      },
      {
        title: 'How can I add my company logo?',
        discription: 'Go to Company Setup → Upload your logo.',
      },
    ],
  },
  {
    heading: ' GST, e-Invoice & Compliance',
    questions: [
      {
        title: 'How can I add my GSTIN?',
        discription:
          'You can:\nAdd GSTIN while creating your account, OR Add it later in Company Setup.\n⚠️ Note: Once you start creating vouchers/transactions, GSTIN or registration type cannot be changed. If needed, create a new company with the correct GSTIN.',
      },
      {
        title: 'Why is GSTIN information automatically filled when I enter my GST number?',
        discription: 'LedgerX fetches your details directly from the GST portal for your convenience. You just need to verify and save.',
      },
      {
        title: 'How does e-Invoice work in LedgerX?',
        discription:
          'Enable e-Invoice in Step 2 of Company Setup.\nProvide your GST portal User ID & Password.\nClick Save & Connect Permanently to avoid entering credentials every time.',
      },
      {
        title: 'Who can generate E-Way Bills in LedgerX?',
        discription:
          'Eligible: Registered dealers and Composition dealers.\nNot eligible: Unregistered businesses (since GSTIN is required).',
      },
    ],
  },
  {
    heading: 'Multi-User Access (Coming Soon)',
    questions: [
      {
        title: 'Is LedgerX multi-user?',
        discription:
          'Not yet. At present, each account is single-user only. A multi-user option with role-based permissions (view, edit, read-only) will be available soon.',
      },
    ],
  },
  {
    heading: ' Support',
    questions: [
      {
        title: 'How does LedgerX support customers?',
        discription: `Call us between 8 AM – 8 PM at: <span style="color:blue">6282000287</span>\nEmail : <a href="mailto:support@ledgerx.biz">support@ledgerx.biz</a>\nUse the support icon in top right corner,choose Report,to raise a ticket and attach screenshots.`,
      },
    ],
  },
];
